import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@innovationnorway/cl-react';

import { ClusterContactDto, ClusterContactStatus, ClusterContactUpdateDto } from 'src/api/v2';

import { toastPromise } from 'src/utils/toast';

import { useContact } from 'src/features/contacts';

interface Props {
  isActive?: boolean;
  clusterContact: ClusterContactDto;
}

const UnretireButton: React.FC<Props> = ({ isActive, clusterContact }) => {
  const { t: tError } = useTranslation('error');
  const { t: tButtons } = useTranslation('buttons');

  const { updateMutation } = useContact(clusterContact.id);

  const activateContact = () => {
    if (clusterContact?.id) {
      const record: ClusterContactUpdateDto = {
        ...clusterContact,

        interestAreaIds: clusterContact?.interestAreas.map((x) => x.id) || [],

        deactivatedDate: undefined,
        status: ClusterContactStatus.Active,
      };

      const promise = updateMutation.mutateAsync(record);

      toastPromise(promise, {
        error: tError('unretire.contact'),
      });
    }
  };

  if (isActive) {
    return null;
  }

  return (
    <Button type="button" onClick={activateContact}>
      {tButtons('unretire')}
    </Button>
  );
};

export default UnretireButton;
